webpackJsonp([11],{

/***/ "G2FD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac086d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("NXeR");
function injectStyle (ssrContext) {
  __webpack_require__("sBkW")
  __webpack_require__("QNdg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac086d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase_firestore__ = __webpack_require__("KvUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_charts__ = __webpack_require__("mbGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_googlemaps_dist_vue_googlemaps_css__ = __webpack_require__("G2FD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_googlemaps_dist_vue_googlemaps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_googlemaps_dist_vue_googlemaps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_googlemaps__ = __webpack_require__("8GWT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("sUu7");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue2_filters___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_googlemaps__["a" /* default */], {
  load: {
    apiKey: 'AIzaSyCw5_2w24XMbEogtcGCbBCrBw9xXKeJ2eU',
    libraries: ['places']
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_charts___default.a);

var app = void 0;
var config = {
  apiKey: 'AIzaSyDx_ArqNQtbyQTtojE26chMDlDJcFAQuuw',
  authDomain: 'sun-ray-holdings.firebaseapp.com',
  databaseURL: 'https://sun-ray-holdings.firebaseio.com',
  projectId: 'sun-ray-holdings',
  storageBucket: '',
  messagingSenderId: '108534571256'
};

__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.initializeApp(config);

var db = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.firestore();

__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
      template: '<App/>',
      components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
    });
  }
});

/***/ }),

/***/ "NXeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QNdg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




var Home = function Home() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "lO7g"));
};
var SellYourPark = function SellYourPark() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "6L2z"));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "xJsL"));
};
var ForgotPassword = function ForgotPassword() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "QLKv"));
};
var AnalyzerEdit = function AnalyzerEdit() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "s/RX"));
};
var AnalyzerReport = function AnalyzerReport() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "9oww"));
};
var AnalyzerHome = function AnalyzerHome() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "yXYf"));
};
var AnalyzerList = function AnalyzerList() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "/yPl"));
};
var MarketScreener = function MarketScreener() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ClBb"));
};
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "YcJa"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/sellyourpark',
    name: 'SellYourPark',
    component: SellYourPark
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  }, {
    path: '/mhp-analyzer',
    name: 'AnalyzerHome',
    component: AnalyzerHome
  }, {
    path: '/mhp-analyzer/edit/:analysisId',
    name: 'AnalyzerEdit',
    component: AnalyzerEdit,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/mhp-analyzer/report/:analysisId',
    name: 'AnalyzerReport',
    component: AnalyzerReport,
    props: true
    // meta: {
    //   requiresAuth: true
    // }
  }, {
    path: '/mhp-analyzer/list',
    name: 'AnalyzerList',
    component: AnalyzerList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/market-screener',
    name: 'MarketScreener',
    component: MarketScreener,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/notfound',
    component: NotFound
  }]
});

router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });

  if (!to.matched.length) {
    next('/notfound');
  } else if (requiresAuth && !currentUser) {
    next('/login');
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "sBkW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b49560bc6715afe99ef4.js